<template>
  <div class="loading-root" @click="next()">
    <img @load="processGrow()" class="loading-gif" src="../assets/loading/loading.gif">
    <div class="loading-process" v-if="!showDot">{{process}}%</div>
    <div class="flash-dot" v-if="showDot"></div>
    <img class="preload-img" :src="imgsrc">
    <div class="preload-div"></div>
  </div>
</template>

<script>
  const avatar = require('../assets/avatar.png')
  let randomId = Math.ceil(Math.random()*45)
  while (randomId === 22) {
    randomId = Math.ceil(Math.random()*45)
  }
  //const code = require('../assets/qcode.png')
  //const resultBg = require(`../assets/result/${randomId}/share${randomId}.png`)
  const translationImg = require(`../assets/result/${randomId}/translation${randomId}.png`)
  import {wxLogin} from '../utils'

  export default {
    name: 'Loading',
    data () {
      return {
        process: 0,
        showDot: false,
        nickname: '你',
        imgsrc: translationImg
      }
    },
    mounted() {
      const self = this
      function preloadAvatar(src) {
        self.$preloadImg({
          src: src,
          x: 115,
          y: 335,
          h: 90,
          w: 90,
          z: 0
        })
      }
      function getQueryString(url, name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = url.split('?').length > 1 && url.split('?')[1].match(reg);
        if (r != null && r != false) {
          return unescape(r[2]);
        }
        return null;
      }
      wxLogin({
        success(data) {
          const imageurl = data['imageurl_big']
          preloadAvatar(getQueryString(imageurl, 'url') ? imageurl : avatar)
          self.nickname = data['username'] || self.nickname
        },
        fail() {
          console.log('fail')
          preloadAvatar(avatar)
        }
      })
     /* this.$preloadImg({
        src:resultBg,
        isBg: true,
        name:'bg',
        z: 1
      })*/
     /* self.$preloadImg({
        src: code,
        isBg: false,
        name:'qcode',
        x: 510,
        y: 1045,
        w: 80,
        h: 80,
        z: 2
      })*/

    },
    methods: {
      processGrow() {
        if (this.process < 100) {
          let random = parseInt(Math.random() * 5)
          this.process = this.process + random > 100 ? 100 : this.process + random
          setTimeout(this.processGrow, random * 15);
        } else{
          this.showDot = true
          this.next = () => {
            this.$router.push(`/index?name=${this.nickname}&article=${randomId}`)
            document.getElementById('audio').play()
          }
          //this.$router.push('/index')
        }
      },
      next() {
      }
    }
  }
</script>
<style scoped>
  .loading-root{
    width: 100%;
    height: 100%;
    //background: url("../assets/loading/loading.gif") center no-repeat;
    background-size: cover;
    position: relative;
  }
  .loading-gif{
    position: absolute;
    left:0;
    width: 100%;
    height: 100%;
  }
  .loading-process{
    font-size: 16px;
    position: absolute;
    top:46%;
    left:62%;
    transform: translate(-50%,-50%);
    color:rgb(239,230,213);
  }
  .flash-dot{
    width: 20px;
    height: 20px;
    position: absolute;
    top:46%;
    left:60%;
    opacity: 0.2;
    transform: translate(-50%,-50%);
    background: url("../assets/loading/dot.png");
    background-size: cover;
    animation: flash 3s .2s ease-in-out infinite;
  }
  .preload-img{
    width: 0;
  }
  .preload-div{
    width: 0;
    background: url('../assets/index_bg.jpg')
    ,url('../assets/index_hand_top.png')
    ,url('../assets/index_hand_bottom.png')
    ,url('../assets/intro/tree.png')
    ,url('../assets/intro/bg.jpg')
    ,url('../assets/result/bg.png')
    ,url('../assets/result/layer.png')
    ,url('../assets/intro/bird.gif')
    ,url("../assets/intro/btn.png");
  }
  @keyframes flash {
    0%{
      transform: translate(-50%,-50%) scale(1);
      opacity: 0.2;
    }
    50%{
      transform: translate(-50%,-50%) scale(1.2);
      opacity: 1;
    }
    100%{
      opacity: .2;
      transform: translate(-50%,-50%) scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Loading.vue